import type { SportsCompetitionsState } from './types';

export const defaultState: SportsCompetitionsState = {
  isLoading: false,
  hasPreloaded: false,
  competitions: {},
  eventTypes: {},
  groups: [],
  allCompetitionIds: []
};
